@if (products()?.length) {
  <div class="cross-sell">
    <div class="cross-sell__title-container">
      <span class="cross-sell__title">
        {{ 'cross_sell_products.together_bought' | translate }}:
      </span>
    </div>
    <products-preview [items]="products()" parentNameForAnalytics="Cross sell products"></products-preview>
  </div>
}
